import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiAnswerWithCitations(question: string, context: string, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are a research assistant answering questions from provided source excerpts. Cite each fact with [N] referring to the numbered excerpt. If the answer is not in the excerpts, say so explicitly. Be concise. Markdown.`;
  try {
    await streamGroq({
      messages: [{ role: 'system', content: system }, { role: 'user', content: `Question: ${question}\n\nSource excerpts:\n${context}\n\nAnswer with [N] citations:` }],
      temperature: 0.2, onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) { onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ to add your free key. The keyword search above works fully without it.'); return; }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
